import React from 'react';
import { Carousel } from 'react-bootstrap';

import QuoteCarouselItem from './quote-carousel-item/quote-carousel-item';

function CarouselItem(quote, hasControls) {
  return (
    <Carousel.Item key={ quote.key }>
      <QuoteCarouselItem
        avatar={ quote.image }
        text={ quote.text }
        author={ quote.author }
        hasControls={ hasControls }
      />
    </Carousel.Item>
  );
}

class QuoteCarousel extends React.Component {
  constructor(props){
    super(props);
    this.quotes = [];
    this.prevIcon = <i className="icon fa fa-angle-left" aria-hidden="true"></i>
    this.nextIcon = <i className="icon fa fa-angle-right" aria-hidden="true"></i>
  }

  render(){
    return (
      <Carousel
        indicators={ false }
        interval={ 12000 }
        prevIcon={ this.prevIcon }
        nextIcon={ this.nextIcon }
        controls={ this.props.quotes.length > 1 }
      >
        { this.props.quotes.map(quote => CarouselItem(quote, (this.props.quotes.length > 1))) }
      </Carousel>
    );
  }
}

export default QuoteCarousel;



// WEBPACK FOOTER //
// ./src/components/quote-carousel/quote-carousel.js